import routes from './routes.constants';
import { waitForGrowthbookInit } from '../plugins/growthbook/growthbook';

// Consumables A/B: mail and push still link to /boost-summary, so the URL
// stays. Control gets the old summary page; the variant gets the boost
// modal (5a while the boost runs, 4a after) over the swap list instead.
// Runs after the global guard, so the app is ready and the user signed
// in — only GrowthBook may still be initialising. The store is loaded
// when the guard runs, not when the route table is, so routes.js stays
// free of the store → main.js chain (a cycle, and unloadable in Jest).
export async function boostSummaryGuard(to, from, next) {
  await waitForGrowthbookInit();
  const { default: store } = await import('../store/store');

  if (!store.getters['app/isTestEnabled']('consumables')) {
    next();
    return;
  }

  store.dispatch('ui/setGlobalModal', 'BoostInfo');
  next({ path: routes.SWAP_LIST, replace: true });
}
